import * as React from "react";

const AppContext = React.createContext("algo malio sal");

export default AppContext;
